module.exports = __webpack_public_path__ + "static/dons-0909c96bc98bb62c11c9f772ecfbb309.jpg";